/**
 * Copies a page's markdown copy to the clipboard.
 *
 * The text arrives from the network, and Safari only lets a clipboard write
 * begin inside the click that asked for it. A ClipboardItem accepts the
 * pending text as a promise, so the write starts at once and completes when
 * the fetch does.
 *
 * @param {import("alpinejs").Alpine} Alpine The Alpine instance.
 */
export default function (Alpine) {
  Alpine.data("copyMarkdown", (path) => ({
    copied: false,
    button: {
      async ["@click"]() {
        const text = fetch(path)
          .then((response) => {
            if (!response.ok) throw new Error(`${path} answered ${response.status}`);
            return response.text();
          })
          .then((markdown) => new Blob([markdown], { type: "text/plain" }));

        await navigator.clipboard.write([new ClipboardItem({ "text/plain": text })]);
        this.copied = true;
        setTimeout(() => (this.copied = false), 1500);
      },
    },
  }));
}
